import { useNavigate } from "react-router-dom";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import ExperienceInputs from "../../../components/Experience/ExperienceInputs";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";
import ShortcutsInput from "../../../components/Shortcuts/ShortcutsInput";

const CreateShortcuts = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Shortcuts",
      route: "/shore/ship-shortcuts/genting-dream",
    },
    {
      title: "Add Shortcuts",
      route: "/shore/ship-shortcuts/genting-dream/add",
    },
  ];

  return (
    <Layout type={"create_per"} module_data={"Shortcuts"}>
      <CustomHeaderTitle title={"Create Shortcuts"} />
      <HeaderBread
        navigation={navigation}
        title={"Add Shortcuts"}
      ></HeaderBread>
      <ShortcutsInput experience={{}} />
    </Layout>
  );
};

export default CreateShortcuts;
